import { useTheme } from "@mui/material";
import { tokens } from "../theme";
import { BarChart } from '@mui/x-charts/BarChart';

const BarChartData = ({ isDashboard = false, stackchart, selectedfilter }) => {
  const showData = stackchart.data || [];
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const getDataByFilter = (data, filter) => {
    if (!data) return Array.from({ length: filter === "month" ? 12 : 31 }, () => 0);
    const expectedLength = filter === "month" ? 12 : 31;
    return Object.values(data).slice(0, expectedLength);
  };

  const uData = getDataByFilter(showData?.dispatchPendingAmount || showData?.dispatchPendingAmountByDay, selectedfilter);
  const pData = getDataByFilter(showData?.materialReceivedAmount || showData?.materialReceivedAmountByDay, selectedfilter);
  const dData = getDataByFilter(showData?.dealerAndInstellerAmount || showData?.dealerAndInstellerAmountByDay, selectedfilter);
  const amtData = getDataByFilter(showData?.stockValue || showData?.stockValueByDay, selectedfilter);
  console.log(dData, "dData")
  const xLabels = selectedfilter === "month" ? [
    'Jan', 'Feb', 'March', 'April', 'May', 'June',
    'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec',
  ] : Array.from({ length: 31 }, (_, i) => (i + 1).toString());

  return (
    <BarChart
      series={[
        { data: amtData, label: 'Stock Value', stack: 'stack1' },
        { data: uData, label: 'Dispatch Pending Amount', stack: 'stack1', color: '#0039e6' },
        { data: pData, label: 'Material Received Amount', stack: 'stack1' },
        { data: dData, label: 'Dealer and Insteller Amount', stack: 'stack1', color: '#00e6e6' },
      ]}
      xAxis={[{
        scaleType: 'band',
        data: xLabels,
        tickPlacement: 'middle',
        tickLabelStyle: {
          angle: 0,
          textAnchor: 'middle',
          fontSize: 12,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis'
        }
      }]}
      yAxis={[{
        min: 0,
        tickInterval: 500000,
        valueFormatter: (value) => {
          if (value >= 1000000) {
            return (value / 1000000).toFixed(1) + 'M';
          } else if (value >= 1000) {
            return (value / 1000).toFixed(0) + 'K';
          }
          return value.toString();
        }
      }]}
      height={350}
      slotProps={{
        legend: {
          direction: 'row',
          position: { vertical: 'top', horizontal: 'middle' },
          padding: 0,
          sx: {
            display: 'flex',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            minWidth: '700px',
            maxWidth: '100%',
            whiteSpace: 'nowrap'
          }
        }
      }}
    />
  );
};

export default BarChartData;